export function buildSafeHashRouteUrl(route: string, baseUri?: string): string {
  const normalizedHashRoute = normalizeHashRoute(route);
  const resolvedBaseUri = baseUri ?? globalThis.document?.baseURI;

  if (!resolvedBaseUri) {
    return normalizedHashRoute;
  }

  try {
    return new URL(normalizedHashRoute, resolvedBaseUri).href;
  } catch {
    const normalizedBaseUri = resolvedBaseUri.split('#')[0].replace(/\/?$/, '/');
    return `${normalizedBaseUri}${normalizedHashRoute}`;
  }
}

function normalizeHashRoute(route: string): string {
  if (route.startsWith('#/')) {
    return route;
  }

  if (route.startsWith('/')) {
    return `#${route}`;
  }

  return `#/${route}`;
}